export default function(data) {
var __t, __p = '';
__p += '<div id="modal-overlay">\n  <div id="modal" class="large-6-fixed medium-7-fixed small-11">\n    <span class="close-modal modal-close-button">\n      <i class="material-icons">close</i>\n    </span>\n    <div class="content"></div>\n  </div>\n</div>\n';
return __p
}